export const setPackage = (category, packageId, dispatch) =>
  dispatch({
    type: 'SET_PACKAGE',
    payload: { category, packageId },
  });

export const resetPackage = (category, dispatch) =>
  dispatch({
    type: 'RESET_PACKAGE',
    payload: category,
  });

export const setActiveTab = (tab, dispatch) =>
  dispatch({
    type: 'SET_ACTIVE_TAB',
    payload: tab,
  });

export const setVolume = (category, planName, volume, dispatch) =>
  dispatch({
    type: 'SET_VOLUME',
    payload: { category, planName, volume },
  });

export const setContacts = (planName, contacts, dispatch) =>
  dispatch({
    type: 'SET_CONTACTS',
    payload: { planName, contacts },
  });

export const setAddons = (id, newVal, dispatch) =>
  dispatch({
    type: 'SET_ADDON',
    payload: { id, newVal },
  });

export const setPricingState = (state, dispatch) =>
  dispatch({
    type: 'SET_STATE',
    payload: state,
  });
